class SignUpDto {
  email!: string;

  password!: string;
}

export default SignUpDto;
